import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bd2f343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper order_wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_4 = { class: "order_page_wrapper" }
const _hoisted_5 = { class: "order_data" }
const _hoisted_6 = { class: "w-100 mb-1" }
const _hoisted_7 = { class: "order_title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "order_status_span_red"
}
const _hoisted_10 = { class: "mt-3 order_data_block" }
const _hoisted_11 = { class: "block_label" }
const _hoisted_12 = { class: "block_info" }
const _hoisted_13 = { class: "mt-3 order_data_block" }
const _hoisted_14 = { class: "block_label" }
const _hoisted_15 = { class: "block_info" }
const _hoisted_16 = { class: "mt-3 order_data_block" }
const _hoisted_17 = { class: "block_label" }
const _hoisted_18 = { class: "block_info" }
const _hoisted_19 = { class: "mt-3 order_data_block" }
const _hoisted_20 = { class: "block_label" }
const _hoisted_21 = { class: "block_info" }
const _hoisted_22 = { class: "button_wrapper" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "order_data mt-6" }
const _hoisted_29 = { class: "receipt_link_wrapper" }
const _hoisted_30 = { class: "my-0" }
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_33 = { class: "my-0" }
const _hoisted_34 = {
  key: 0,
  class: "order_data mt-6"
}
const _hoisted_35 = { class: "w-100" }
const _hoisted_36 = { class: "my-0" }

export function render(_ctx, _cache) {
  const _component_v_last_viewed_clients_tabs = _resolveComponent("v-last-viewed-clients-tabs")
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_v_client_tabs_menu = _resolveComponent("v-client-tabs-menu")
  const _component_v_datatable = _resolveComponent("v-datatable")
  const _component_paymentExplanation = _resolveComponent("paymentExplanation")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_last_viewed_clients_tabs, {
      currentClientId: _ctx.order?.clientId
    }, null, 8, ["currentClientId"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showAlert,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showAlert) = $event)),
      title: 'order.alert_change_status',
      text: 'order.are_you_sure',
      successButtonText: _ctx.$t('order.confirm'),
      cancelButtonText: _ctx.$t('order.cancel'),
      onSuccess: _ctx.changeOrderStatus,
      onCancel: _cache[1] || (_cache[1] = $event => (_ctx.showAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showPOSAlert,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showPOSAlert) = $event)),
      title: 'order.alert_pos_pay',
      text: 'order.pos_alert_text',
      successButtonText: _ctx.$t('order.confirm'),
      cancelButtonText: _ctx.$t('order.cancel'),
      onSuccess: _cache[3] || (_cache[3] = $event => (_ctx.pay('card'))),
      onCancel: _cache[4] || (_cache[4] = $event => (_ctx.showPOSAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showCashAlert,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.showCashAlert) = $event)),
      title: 'order.alert_cash_pay',
      text: 'order.cash_alert_text',
      successButtonText: _ctx.$t('order.confirm'),
      cancelButtonText: _ctx.$t('order.cancel'),
      onSuccess: _cache[6] || (_cache[6] = $event => (_ctx.pay('cash'))),
      onCancel: _cache[7] || (_cache[7] = $event => (_ctx.showCashAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_client_tabs_menu, {
        clientId: _ctx.order?.clientId,
        activeTab: "payment-info"
      }, null, 8, ["clientId"]),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = $event => (_ctx.$router.push(`/client/${_ctx.order?.clientId}/payment-info`))),
        class: "button button_back",
        disabled: !_ctx.order?.clientId
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('order.payments')), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("p", { class: "order" }, "ORD #" + _toDisplayString(_ctx.order?.orderId?.toString().padStart(8, '0')), 513), [
                [_vShow, _ctx.isLoaded]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass('order_status status_text_' + _ctx.getOrderStatus(_ctx.generateOrderStatus(_ctx.order?.processingStatus, _ctx.order?.paidStatus)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('order_status.' + _ctx.getOrderStatus(_ctx.generateOrderStatus(_ctx.order?.processingStatus ?? 1, _ctx.order?.paidStatus)))), 1),
                (_ctx.order?.resultDescription && _ctx.order?.paidStatus != 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, ": "))
                  : _createCommentVNode("", true),
                (_ctx.order?.resultDescription && _ctx.order?.paidStatus != 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.order?.resultDescription)), 1))
                  : _createCommentVNode("", true)
              ], 2), [
                [_vShow, _ctx.isLoaded]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('order.amount')), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getFormatedAmount(_ctx.order?.total)) + " " + _toDisplayString(_ctx.order?.currencySign), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('order.date')), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getFormatedDate(_ctx.order?.queueDate, "DD.MM.yyyy") || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('order.payments_processing_provider')), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.order?.bankProcessingProviderName ? _ctx.$t(_ctx.getOrderPaymentsProcessingProvider(_ctx.order?.bankProcessingProviderName)) : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('order.description')), 1),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.order?.comment), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.canPayOrder && _ctx.hasPayPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "order_pay_button",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.showPOSAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('order.pay_by_card')), 9, _hoisted_23))
            : _createCommentVNode("", true),
          (_ctx.canPayOrder && _ctx.hasPayPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "order_pay_button",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.showCashAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('order.pay_in_cash')), 9, _hoisted_24))
            : _createCommentVNode("", true),
          (_ctx.order?.processingStatus == 0 && _ctx.hasCancelPermission && !_ctx.order?.isBankTransfer)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "order_cancel_button",
                onClick: _cache[11] || (_cache[11] = $event => (_ctx.showAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('order.cancel_order')), 9, _hoisted_25))
            : _createCommentVNode("", true),
          (_ctx.order?.processingStatus == -1 && _ctx.hasResumePermission && !_ctx.order?.isBankTransfer)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "order_resume_button",
                onClick: _cache[12] || (_cache[12] = $event => (_ctx.showAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('order.resume_order')), 9, _hoisted_26))
            : _createCommentVNode("", true),
          (_ctx.order?.processingStatus == 2 && _ctx.order?.paidStatus == 1 && !_ctx.order?.isRefunded && _ctx.hasRefundPermission && !_ctx.order?.isBankTransfer)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: "order_refund_button",
                onClick: _cache[13] || (_cache[13] = $event => (_ctx.showAlert = true)),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('order.refund_order')), 9, _hoisted_27))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t('order.order_details')), 1),
            (_ctx.order?.receiptUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "receipt_link",
                  href: _ctx.order?.receiptUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t('order.open_receipt')), 9, _hoisted_31))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_datatable, {
            class: "mt-3",
            columTemplates: _ctx.orderItemsColumTemplates,
            data: _ctx.orderItemsTableData,
            isLoading: !_ctx.isLoaded
          }, null, 8, ["columTemplates", "data", "isLoading"]),
          (_ctx.order?.explanation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t('order.explanation.header')), 1),
                _createVNode(_component_paymentExplanation, {
                  explanation: _ctx.order.explanation,
                  currencySign: _ctx.order.currencySign
                }, null, 8, ["explanation", "currencySign"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.refundOrderTableData.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t('order.refund_information')), 1)
              ]),
              _createVNode(_component_v_datatable, {
                class: "mt-3 pointer",
                columTemplates: _ctx.refundOrderColumTemplates,
                data: _ctx.refundOrderTableData,
                isLoading: !_ctx.isLoaded,
                onClickOnRow: _ctx.openRefundOrder
              }, null, 8, ["columTemplates", "data", "isLoading", "onClickOnRow"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}